import { types } from "../types/types";

const initialState = {
    loginForm : {},
    practicajaForm: {},
    tiendaForm: {},
    tarjetaForm: {},
    asignarPracticajaForm: {},
    asignarVentanillaForm: {},
}

export const formsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.formsValidStart:
            return {
                ...state,
                [action.payload]: {
                    loading: true
                }
            }

        case types.formsValidFinish:
            return {
                ...state,
                [action.payload]: {
                    ...state[action.payload],
                    loading: false
                }
            }

        case types.formsValidError:
            return {
                ...state,
                [action.payload.formName]: {
                    ...state[action.payload.formName],
                    error: true,
                    msg: action.payload.msg
                }
            }
        
        case types.formsValidMsg:
            return {
                ...state,
                [action.payload.formName]: {
                    ...state[action.payload.formName],
                    error: false,
                    msg: action.payload.msg
                }
            }

        case types.formsValidDestroy:
            return {
                ...state,
                [action.payload.formName]: {}
            }
    
        default:
            return state;
    }
}